import { Button, Stack, Typography } from "@mui/material"
import { IProjectTeamPreviewItem } from "../../api/types"
import { formatNumber } from "../../common/FormatNumber"
import { ProjectTeamMemberCard } from "./ProjectTeamMemberCard"

type Props = {
  members: IProjectTeamPreviewItem[]
  membersTotal: number
  onOpenAllMembers: () => void
  entity?: 'project' | 'team'
}

export const ProjectTeamSection = ({ members, membersTotal, onOpenAllMembers, entity = 'project' }: Props) => {
  const extraMembersCount = Math.max(0, membersTotal - members.length)

  return (
    <Stack gap={1.5}>
      <Typography variant="black-14-medium">
        Членов команды: {formatNumber(membersTotal)}
      </Typography>
      <Stack gap={1}>
        {members.map((member) => (
          <ProjectTeamMemberCard
            key={`${member.user.id ?? 'deleted'}-${member.team_role}-${member.is_author ? 'author' : 'member'}`}
            member={member}
            entity={entity}
          />
        ))}
      </Stack>
      {extraMembersCount > 0 && (
        <Button
          variant="action"
          onClick={onOpenAllMembers}
          sx={{ alignSelf: 'flex-start' }}
        >
          Ещё {extraMembersCount} участников
        </Button>
      )}
    </Stack>
  )
}
